var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-autopilots-add-details"},[_c('div',{staticClass:"project-autopilots-add-details-wrapper"},[_c('div',{staticClass:"project-autopilots-add-details-head"},[_c('TText',{attrs:{"text":_vm.autopilot.function,"font_weight":"500","size":"24"}}),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push({name: 'ProjectAutoPilotsAdd'})}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_c('div',{staticStyle:{"display":"flex","grid-gap":"8px","align-items":"center"}},_vm._l((_vm.getUObjectsFiltered({type: 'autopilots', filter: {function: _vm.autopilot.function}})),function(level){return _c('v-btn',{key:`aplevel${level.id}`,staticClass:"ml-1",attrs:{"small":"","color":_vm.autopilot.id === level.id?'green':''},on:{"click":function($event){_vm.autopilot.id !== level.id?
          _vm.updateUObject({
            url: [
            {projects: _vm.project_id},
            {autopilotprojects: _vm.autopilotprojects.id}
            ],
            update: {
              'add#autopilots': [level.id]
            }
          }).then(() => {
            _vm.updateUObject({
              url: [
              {projects: _vm.project_id},
              {autopilotprojects: _vm.autopilotprojects.id}
              ],
              update: {
                'remove#autopilots': [_vm.autopilotprojects.autopilots[0]]
              }
            })
            })
          :
          ''}}},[_vm._v(" "+_vm._s(level.level)+" ")])}),1),_c('TText',{attrs:{"text":_vm.autopilot.description}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }